/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-10-19T12:00:00+05:00
Intent: Reword backend plan-limit errors ("contests", "up to 0") for clients.
*/

/**
 * Plan-limit errors come straight from the backend, e.g.
 *   "You are allowed to create up to 0 non-integrated contests. Your plan's
 *    remaining allowance is for integrated ones."
 * The client panel calls them campaigns, and "up to 0" reads like a glitch, so
 * the sentence is reworded before it is shown. Any other message is returned
 * unchanged with `isPlanLimit: false`.
 */
export function formatPlanLimitMessage(message: string): { text: string; isPlanLimit: boolean } {
  const text = String(message ?? '');
  const isPlanLimit = /allowed to create up to \d+/i.test(text) || /remaining allowance/i.test(text);
  if (!isPlanLimit) return { text, isPlanLimit };

  const reworded = text
    // "allowed to create up to 0 X" means none are left: say so without the number.
    .replace(/\ballowed to create up to 0\s+/i, 'not allowed to create more ')
    .replace(/\bcontest(s?)\b/gi, (word, plural) =>
      (word[0] === 'C' ? 'Campaign' : 'campaign') + plural);
  return { text: reworded, isPlanLimit };
}
